'use client';
import { useEffect } from 'react';

const useFont = (link?: string) => {
  useEffect(() => {
    if (!link) return;

    const fontLink = document.createElement('link');
    fontLink.href = link;
    fontLink.rel = 'stylesheet';
    document.head.appendChild(fontLink);

    return () => {
      document.head.removeChild(fontLink);
    };
  }, [link]);
};

export default useFont;
